export enum OwnershipStatus {
  OWN = 'OWN',
  RELATIVE_OWNED = 'RELATIVE_OWNED',
  RENT = 'RENT',
  UNKNOWN = 'UNKNOWN',
}
